import {
  AmberCherryGrain,
  HarvestMapleGrain,
  NeoWallNutGrain,
  PhantomCocoaGrain,
  FontHillPairGrain,
  DriftReconGrain,
} from "assets/images";
const BASE_URL = "https://api.hsiheadwalls.com/";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const passwordRegExp =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&/{}()_\-+=,*]).{8,}$/;
const emailRegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const AUTH = {
  SIGNUP: "user/signup",
  LOGIN: "user/signin",
  FORGOT_PASSWORD: "user/forgotPassword",
  RESET_PASSWORD: "user/resetPassword",
  CHANGE_PASSWORD: "user/changePassword",
  GET_PROFILE: "user/getProfile",
  UPDATE_PROFILE: "user/updateProfile",
  REFRESH_TOKEN: "user/refreshToken",
};

const HEADWALL = {
  GET_PRODUCTS: "user/getProducts",
  GET_SERVICES: "user/getFilteredServices",
  GET_SPECIFICATIONS: "/user/getServiceItems",
  SAVE_DESIGN: "user/createDesign",
  DOWNLOAD_DESIGN: "user/downloadDesignImage",
  EDIT_DESIGN: "user/getDesignById/{designId}",
  UPDATE_DESIGN: "user/updateDesign/{designId}",
  GET_TEMPLATES: "user/getDesignTemplates",
  GET_TEMPLATE_BY_ID: "/user/getTemplateDesignById",
  GET_CATEGORIES: "user/getCategories",
  GET_MANUFACTURERS: "user/getManufacturers",
  GET_ACCESSORIES: "user/getFilteredAccessories",
  GET_ACCESSORIE_RAILS: "user/getRails",
  GET_ACCESSORIE_CATEGORY: "user/getAccessoryCategories",
};

const DASHBOARD = {
  GET_DESINGS: "user/getDesigns",
  CREATE_FOLDER: "user/createFolder",
  GET_FOLDERS: "user/getAllFolders",
  GET_FOLDERS_DATA: "user/getFolderData",
  MOVE_TO_FOLDER: "user/moveToFolder",
  TRASH_FOLDER: "user/trashFolder",
  TRASH_DESIGN: "user/trashDesigns",
  RENAME_FOLDER: "user/renameFolder",
  REQUEST_DESIGN: "user/designRequest",
  DOWNLOAD_FOLDER_DESIGNS: "user/downloadDesignsZip",
  DOWNLOAD_DESIGN: "user/downloadDesign",
  FILTER_DESIGN: "user/getFilteredDesigns",
  GET_TRASHED_DESIGNS: "user/getTrashedDesigns",
  GET_TRASHED_FOLDERS: "user/getTrashedFolders",
  GET_TRASHED_FOLDER_DESIGNS: "user/getTrashedFolderData",
  DELETE_TRASHED_DESIGNS: "user/deleteDesigns",
  DELETE_TRASHED_FOLDER: "user/deleteTrashFolder",
  CLEAR_TRASH: "user/deleteAllTrash",
  RESTORE_TRASHED_ITEM: "user/restoreTrashedItem",
};

const PRODUCT = {
  INFINITY: "infinity",
  AXIOM: "axiom",
  COMPASS: "compass",
  ARRAY: "array",
  CONSOLE: "console",
  ELOQUENCE: "eloquence",
  SECURITY: "security_console",
  HIDDEN: "hidden",
};

const pixelPerInch = 0.056;

const RAILS = {
  INFINITY: [
    { label: 0, value: 0 },
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
    { label: 6, value: 6 },
    { label: 7, value: 7 },
    { label: 8, value: 8 },
    { label: 9, value: 9 },
    { label: 10, value: 10 },
    { label: 11, value: 11 },
    { label: 12, value: 12 },
    { label: 13, value: 13 },
    { label: 14, value: 14 },
    { label: 15, value: 15 },
    { label: 16, value: 16 },
    { label: 17, value: 17 },
  ],

  AXIOM: [
    { label: 0, value: 0 },
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
    { label: 6, value: 6 },
  ],

  ELOQUENCE: [
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
    { label: 6, value: 6 },
    { label: 7, value: 7 },
  ],
  //inches
  COMPASS: [
    { label: 12, value: 12 },
    { label: 18, value: 18 },
    { label: 24, value: 24 },
    { label: 30, value: 30 },
    { label: 36, value: 36 },
    { label: 42, value: 42 },
    { label: 48, value: 48 },
  ],
  //ft
  ARRAY: [
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
  ],

  CONSOLE: [
    { label: 11.25, value: 11.25 },
    { label: 13.625, value: 13.625 },
    { label: 16, value: 16 },
    { label: 18.375, value: 18.375 },
    { label: 20.75, value: 20.75 },
    { label: 23.125, value: 23.125 },
    { label: 25.5, value: 25.5 },
    { label: 27.875, value: 27.875 },
    { label: 30.25, value: 30.25 },
    { label: 32.625, value: 32.625 },
    { label: 35, value: 35 },
    { label: 37.375, value: 37.375 },
    { label: 39.75, value: 39.75 },
    { label: 42.125, value: 42.125 },
    { label: 44.5, value: 44.5 },
    { label: 46.875, value: 46.875 },
    { label: 49.25, value: 49.25 },
    { label: 51.625, value: 51.625 },
    { label: 54, value: 54 },
    { label: 56.375, value: 56.375 },
    { label: 58.75, value: 58.75 },
    { label: 61.125, value: 61.125 },
    { label: 63.5, value: 63.5 },
    { label: 65.875, value: 65.875 },
    { label: 68.25, value: 68.25 },
    { label: 70.625, value: 70.625 },
    { label: 73, value: 73 },
    { label: 75.375, value: 75.375 },
  ],

  SECURITY_SURFACE_MOUNTED: [
    { label: 14.125, value: 14.125 },
    { label: 16.5, value: 16.5 },
    { label: 18.875, value: 18.875 },
    { label: 21.25, value: 21.25 },
    { label: 23.625, value: 23.625 },
    { label: 26, value: 26 },
    { label: 28.375, value: 28.375 },
    { label: 30.75, value: 30.75 },
    { label: 33.125, value: 33.125 },
    { label: 35.5, value: 35.5 },
    { label: 37.875, value: 37.875 },
    { label: 40.25, value: 40.25 },
    { label: 42.625, value: 42.625 },
    { label: 45, value: 45 },
    { label: 47.375, value: 47.375 },
    { label: 49.75, value: 49.75 },
    { label: 52.125, value: 52.125 },
    { label: 54.5, value: 54.5 },
    { label: 56.875, value: 56.875 },
    { label: 59.25, value: 59.25 },
    { label: 61.625, value: 61.625 },
    { label: 64, value: 64 },
    { label: 66.375, value: 66.375 },
    { label: 68.75, value: 68.75 },
    { label: 71.125, value: 71.125 },
    { label: 73.5, value: 73.5 },
    { label: 75.875, value: 75.875 },
    { label: 78.25, value: 78.25 },
  ],

  SECURITY_ENCLOUSRE: [
    { label: 0, value: 0 },
    { label: 1, value: 1 },
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
  ],

  SECURITY_RECESSED: [
    { label: 11.375, value: 11.375 },
    { label: 13.75, value: 13.75 },
    { label: 16.125, value: 16.125 },
    { label: 18.5, value: 18.5 },
    { label: 20.875, value: 20.875 },
    { label: 23.25, value: 23.25 },
    { label: 25.625, value: 25.625 },
    { label: 28, value: 28 },
    { label: 30.375, value: 30.375 },
    { label: 32.75, value: 32.75 },
    { label: 35.125, value: 35.125 },
    { label: 37.5, value: 37.5 },
    { label: 39.875, value: 39.875 },
    { label: 42.25, value: 42.25 },
    { label: 44.625, value: 44.625 },
    { label: 47, value: 47 },
    { label: 49.375, value: 49.375 },
    { label: 51.75, value: 51.75 },
    { label: 54.125, value: 54.125 },
    { label: 56.5, value: 56.5 },
    { label: 58.875, value: 58.875 },
    { label: 61.25, value: 61.25 },
    { label: 63.625, value: 63.625 },
    { label: 66, value: 66 },
    { label: 68.375, value: 68.375 },
    { label: 70.75, value: 70.75 },
    { label: 73.125, value: 73.125 },
    { label: 75.5, value: 75.5 },
  ],

  SECURITY_INSIGHT: [
    { label: 17.125, value: 17.125 },
    { label: 19.5, value: 19.5 },
    { label: 21.875, value: 21.875 },
    { label: 24.25, value: 24.25 },
    { label: 26.625, value: 26.625 },
    { label: 29, value: 29 },
    { label: 31.375, value: 31.375 },
    { label: 33.75, value: 33.75 },
    { label: 36.125, value: 36.125 },
    { label: 38.5, value: 38.5 },
    { label: 40.875, value: 40.875 },
    { label: 43.25, value: 43.25 },
    { label: 45.625, value: 45.625 },
    { label: 48, value: 48 },
    { label: 50.375, value: 50.375 },
    { label: 52.75, value: 52.75 },
    { label: 55.125, value: 55.125 },
    { label: 57.5, value: 57.5 },
    { label: 59.875, value: 59.875 },
  ],

  HIDDEN_SINGLE: [
    { label: 24, value: 24 },
    { label: 32, value: 32 },
  ],

  HIDDEN_DOUBLE: [
    { label: 48, value: 48 },
    { label: 64, value: 64 },
  ],
};

const CEILING_HEIGHT = [
  { label: 8, value: 8 },
  { label: 9, value: 9 },
  { label: 10, value: 10 },
  { label: 11, value: 11 },
  { label: 12, value: 12 },
];

const RAIL_INCHES = [
  { label: 0, value: 0 },
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  { label: 7, value: 7 },
  { label: 8, value: 8 },
  { label: 9, value: 9 },
  { label: 10, value: 10 },
  { label: 11, value: 11 },
];

const COLORS = [
  "#384957",
  "#446454",
  "#114867",
  "#c4bcaa",
  "#442c1c",
  "#6c2b31",
  "#1c8c8c",
  "#79736d",
  "#f4f4e4",
  "#a5a5a5",
];

const COMPASS = {
  SECTION_1_HEIGHT: 359.285714286,
  SECTION_2_HEIGHT: 355,
  SECTION_3_HEIGHT: 613.928571429,
};

const ARRAY = {
  // SECTION_2_HEIGHT: 535.714285714,
  // SECTION_3_HEIGHT: 535.714285714,
  SECTION_2_HEIGHT: 529.107142857,
  SECTION_3_HEIGHT: 518.928571429,
};

const COMPASS_INNER_PANELS_MARGIN_FROM_TOP = {
  1: 20.1785714286,
  2: 134.4642857143,
  3: 376.1542857143,
  4: 490.44,
  5: 604.7257142857,
  6: 741.19,
  7: 950.6542857143,
};

const GRAINS = {
  7919: AmberCherryGrain,
  7953: HarvestMapleGrain,
  7991: NeoWallNutGrain,
  8213: PhantomCocoaGrain,
  10745: FontHillPairGrain,
  y0804: DriftReconGrain,
};

export {
  pixelPerInch,
  phoneRegExp,
  passwordRegExp,
  emailRegExp,
  BASE_URL,
  AUTH,
  HEADWALL,
  PRODUCT,
  DASHBOARD,
  RAILS,
  CEILING_HEIGHT,
  RAIL_INCHES,
  COLORS,
  COMPASS,
  ARRAY,
  GRAINS,
  COMPASS_INNER_PANELS_MARGIN_FROM_TOP,
};
